import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, getMe, tokenStore } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const bootstrap = useCallback(async () => {
    const t = tokenStore.get();
    if (!t) { setLoading(false); return; }
    try {
      const me = await getMe();
      setUser(me);
    } catch (e) {
      tokenStore.clear();
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const signIn = async (email, password) => {
    const data = await apiLogin(email, password);
    tokenStore.set(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signOut = () => {
    tokenStore.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut, isAuthed: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
